import { RootReducer } from '../rootReducer';

export const selectModals = (state: RootReducer) => state.modals;

export const selectModalProps = (state: RootReducer) => state.modals.modalProps;
